import styled from "styled-components";
import Form from "react-bootstrap/esm/Form";
import { FormGroupProps } from "./types";
import { RequiredComponent } from "./RequiredComponent";

const FormLabelDefault = styled(Form.Label)`
  margin: 0px 0px 0.5rem 0px;
`;
const FormLabelWithHint = styled(Form.Label)`
  margin: 0px 0px 0px 0px;
`;

export const FormLabel = ({
  displayValue,
  required,
  hint,
  invalid,
  htmlFor,
}: FormGroupProps) => {
  return (
    <>
      {hint ? (
        <FormLabelWithHint htmlFor={htmlFor}>
          {displayValue}
          <RequiredComponent invalid={invalid} required={required} />
        </FormLabelWithHint>
      ) : (
        <FormLabelDefault htmlFor={htmlFor}>
          {displayValue}
          <RequiredComponent invalid={invalid} required={required} />
        </FormLabelDefault>
      )}
    </>
  );
};
